import { sizeUnits } from "@megaron/catalog-contracts";
import { HttpAction } from "@megaron/http-service";
import { baseDocSerializer } from "@megaron/resource";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const itemDocSerializer = Serializers.object({
  ...baseDocSerializer("item").fields,

  itemId: Serializers.string,
  productId: Serializers.string,
  itemName: Serializers.string,
  gtin: Serializers.string.nullable(),
  box: Serializers.integer.nullable(),
  layer: Serializers.integer.nullable(),
  pallet: Serializers.integer.nullable(),
  size: Serializers.decimal,
  sizeUnit: Serializers.stringOneOf(...sizeUnits),
  massKg: Serializers.decimal,
  bcId: uuidSerializer.nullable(),
  productGroup: Serializers.string,
  title: Serializers.string,
  variantTitle: Serializers.string,
  brand: Serializers.string,
  description: Serializers.string,
  handle: Serializers.string.nullable(),
  shopifyVariantId: Serializers.string.nullable(),
  shopifyProductId: Serializers.string.nullable(),
  cost: Serializers.decimal.nullable(),
  isLoyalty: Serializers.boolean,
  defaultProfit: Serializers.decimal.nullable(),
  isInAvailability: Serializers.boolean,
});

export type ItemDoc = SerializerValue<typeof itemDocSerializer>;

export const itemsSortFields = ["box", "pallet", "layer", "size", "gtin"] as const;
export type ItemSortField = (typeof itemsSortFields)[number];

export const itemActions = {
  searchItems: HttpAction({
    path: "/items",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
      sort: Serializers.sortFilter(itemsSortFields).asJsonString(),
      isLoyalty: Serializers.jsonString(Serializers.boolean),
      groups: Serializers.jsonString(Serializers.array(Serializers.string)),
      isArchived: Serializers.jsonString(Serializers.boolean),
      isInAvailability: Serializers.jsonString(Serializers.boolean),
    }).partial(),
    valueSerializer: Serializers.paginatedList(itemDocSerializer),
    requiresAuth: true,
  }),

  searchProductGroups: HttpAction({
    path: "/items/productsGroups",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
    }).partial(),
    valueSerializer: Serializers.string.array(),
    requiresAuth: true,
  }),

  searchProductIds: HttpAction({
    path: "/items/productsIds",
    qsSerializer: Serializers.object({
      searchText: Serializers.string,
      isArchived: Serializers.jsonString(Serializers.boolean),
    }).partial(),
    valueSerializer: Serializers.string.array(),
    requiresAuth: true,
  }),
};
